import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ContactUsDialogComponent } from './contact-us-dialog/contact-us-dialog.component';
import { FooterComponent } from './footer/footer.component';
import { LayoutComponent } from './layout/layout.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { SideMenuItemComponent } from './side-menu-item/side-menu-item.component';
import { UserItemComponent } from './user-item/user-item.component';

@NgModule({
  declarations: [
    ContactUsDialogComponent,
    FooterComponent,
    LayoutComponent,
    MenuItemComponent,
    SideMenuItemComponent,
    UserItemComponent,
  ],
  imports: [SharedModule],
})
export class ThemeModule { }
